import { render, staticRenderFns } from "./AboutInfoVideo.vue?vue&type=template&id=d96658fe&scoped=true&"
var script = {}
import style0 from "./AboutInfoVideo.vue?vue&type=style&index=0&id=d96658fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96658fe",
  null
  
)

export default component.exports